import { Injectable } from '@angular/core';
import { Store, guid } from '@datorama/akita';

import { UserNetworkState } from 'user/model/user-network.state';
import { UserNetworkType } from 'user/model/user-network.type';

export interface CoachSettingsGeneralExternalConnectionState {
	networkState: UserNetworkState;
	networkType: UserNetworkType;
	calendarsId: string[];
	isSynchronizing: boolean;
	isReconnecting: boolean;
	hasSynchronizedCalendars: boolean;
}

@Injectable()
export class CoachSettingsGeneralExternalConnectionStore extends Store<CoachSettingsGeneralExternalConnectionState> {
	constructor() {
		super(
			{
				hasSynchronizedCalendars: false,
				networkState: UserNetworkState.NOT_ACTIVE,
			},
			{ name: `ui-coach-settings-general-external-connection${guid()}` }
		);
	}
}
